module.exports = __webpack_public_path__ + "img/banner-1.9b08058b.png";